// store/useMainStore.js
import { create } from 'zustand';

const initialState = {
  isModalOpen: null,
  projectDD: [],
  model: {},
  projects: [],
  // List filter — mirrors the projectId in the route/query. Owned by ModelManagement.jsx.
  projectId: null,
  // Add/Edit Model form field — the project the model will belong to. Owned by ModelPopup.
  // Kept separate from `projectId` on purpose: the route-sync effect in ModelManagement.jsx
  // rewrites `projectId`, which would wipe the user's dropdown pick mid-form.
  formProjectId: null,
  modelInfo: null,
  modelDataInfo: null,
  modelName: null,
  modelDetailInputField: null,
  modelType: null,
  visibility: 'private', // 'public' | 'private'
  tags: '', // comma-separated tags string surfaced in the Public Model Hub
};

const useModelManagementStore = create((set) => ({
  ...initialState,

  setIsModalOpen: (value) => set({ isModalOpen: value }),
  setProjectDD: (value) => set({ projectDD: Array.isArray(value) ? value : [] }),
  setModel: (value) => set({ model: value || {} }),
  setProjects: (value) => set({ projects: Array.isArray(value) ? value : [] }),
  setProjectId: (projectId) => set({ projectId }),
  setFormProjectId: (formProjectId) => set({ formProjectId }),
  setModelInfo: (value) => set({ modelInfo: value }),
  setModelDataInfo: (value) => set({ modelDataInfo: value }),
  setModelName: (value) => set({ modelName: value }),
  setModelDetailInputField: (value) => set({ modelDetailInputField: value }),
  setModelType: (value) => set({ modelType: value }),
  setVisibility: (value) => set({ visibility: value || 'private' }),
  setTags: (value) => set({ tags: value ?? '' }),

  resetModelForm: () =>
    set({
      modelName: null,
      modelDetailInputField: null,
      modelType: null,
      modelInfo: null,
      modelDataInfo: null,
      formProjectId: null,
      visibility: 'private',
      tags: '',
      isModalOpen: false,
    }),

  resetAll: () => set({ ...initialState }),
}));

export default useModelManagementStore;